import React from 'react';
import reactSelect from 'react-select';

const Sales = () => {
    return (
        <div className="row">
            <div className="col-md-4">
                <div className="form-group">
                    <label>کسب و کار</label>
                    <select className="form-control">
                        <option value="">انتخاب کنید</option>
                        <option value="1">موفق</option>
                        <option value="2">ناموفق</option>
                    </select>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label>گروه</label>
                    <select className="form-control">
                        <option value="">انتخاب کنید</option>
                        <option value="1">موفق</option>
                        <option value="2">ناموفق</option>
                    </select>
                </div>
            </div>
            <div className="col-md-3">
                <div className="form-group">
                    <label>سرویس</label>
                    <select className="form-control">
                        <option value="">انتخاب کنید</option>
                        <option value="1">موفق</option>
                        <option value="2">ناموفق</option>
                    </select>
                </div>
            </div>
            <div className="col-md-1" style={{marginTop: 29}}>
                <button className="btn btn-info w-100">جستجو</button>
            </div>
            <div className="col-md-12 mt-3">
                <div className="table-responsive bg-white p-4" style={{borderRadius: 7}}>
                    <table className="table custom-table-style table-hover mb-0">
                        <thead>
                        <tr>
                            <th>نام استفاده کننده</th>
                            <th>نام صاحب اعتبار</th>
                            <th>کسب و کار</th>
                            <th>گروه</th>
                            <th>سرویس</th>
                            <th>خدمت</th>
                            <th>آدرس</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>1</td>
                            <td>450,870 هزارتومان</td>
                            <td>450,870 هزارتومان</td>
                            <td>450,870 هزارتومان</td>
                            <td>450,870 هزارتومان</td>
                            <td>450,870 هزارتومان</td>
                            <td>450,870 هزارتومان</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Sales;